import { mapState } from 'vuex';

//- 禮物
import GiftItemComponent from '@/components/GiftItem/GiftItem.vue';
//- 分頁器
import PagenationComponent from '@/components/Pagenation/Pagenation.vue';

export default {
  name: 'GiftPointsExchangeModalComponent',
  components: {
    GiftItemComponent,
    PagenationComponent,
  },
  props: {
    //- 是否顯示禮物兌換紀錄
    isGiftExchangeRecordModalShow: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      //- 目前選擇要顯示的標題
      nowSelectType: 'doing',
      //- 處理中的分頁器內容
      doing_pagenationData: {
        //- 目前頁面
        currentPage: 1,
        //- 一頁幾筆
        perPage: 3,
        //- 總筆數
        total: 5,
      },
      //- 禮物兌換紀錄的已完成內容
      fields: [
        { key: 'updated_at', label: '處理時間', sortable: false, class: 'text-center' },
        { key: 'name', label: '兌換禮物', sortable: false, class: 'text-center' },
      ],
      //- 已完成的分頁器內容
      done_pagenationData: {
        //- 目前頁面
        currentPage: 1,
        //- 一頁幾筆
        perPage: 5,
        //- 總筆數
        total: 2,
      },
    }
  },
  mounted() {

  },
  methods: {
    //- 關閉
    closeHandler: function() {
      let vm = this;
      // vm.resetHandler();
      //- 呼叫父元件
      vm.$emit('closeHandler');
    },
    //- 初始化
    resetHandler: function() {
      let vm = this;
      vm.nowSelectType = 'doing';
      // 這邊另外帶入提示, 這樣可以確定 API 打完才關提示
      vm.$Swal.fire({
          title: '資料載入中, 請稍候',
          heightAuto: false,
          allowOutsideClick: false,
          onOpen: function onOpen() {
            vm.$Swal.showLoading();
          }
        })
        //- showRequestLoadingSwal 設定為 false, 防止 Swal 跳兩次
      window.showRequestLoadingSwal = false;
      // 取得處理中的列表
      vm.$store.dispatch('gift_manager/getGiftsProcessingRecord').then(() => {
        //- 帶入處理中的分頁
        vm.doing_pagenationData = vm.$_.cloneDeep(vm.doingPagenationData);
        //- 取得已完成的列表
        vm.$store.dispatch('gift_manager/getGiftsFinishedRecord').then(() => {
          //- 手動關閉
          vm.$Swal.close();
          //- showRequestLoadingSwal 設定為 true, 讓之後打 API 會顯示提示
          window.showRequestLoadingSwal = true;
          //- 帶入已完成的分頁
          vm.done_pagenationData = vm.$_.cloneDeep(vm.donePagenationData);
        })
      })
    },
    //- 切換標題種類
    changeTypeHandler: function(type) {
      let vm = this;
      //- 判斷種類
      switch (type) {
        case 'doing':
          vm.nowSelectType = 'doing';
          break;
        case 'done':
          vm.nowSelectType = 'done';
          break;
        default:
          break;
      }
    },
    //- 切換分頁器
    changePageHandler: function(page, type) {
      let vm = this;
      let pageData = {
        page: page
      }
      switch (type) {
        case 'doing':
          //- 取得處理中的列表
          vm.$store.dispatch('gift_manager/getGiftsProcessingRecord', pageData).then(() => {
            //- 帶入正確的頁數
            vm.doing_pagenationData = vm.$_.cloneDeep(vm.doingPagenationData);
            //- 重置幻燈片及方向
            vm.$_.forEach(vm.$refs.GiftItemComponent, function(i, k) {
              i.resetHandler();
            });
            //- 滑動置頂
            vm.slideToTop();
          });
          break;
        case 'done':
          //- 取得已完成的列表
          vm.$store.dispatch('gift_manager/getGiftsFinishedRecord', pageData).then(() => {
            //- 帶入正確的頁數
            vm.done_pagenationData = vm.$_.cloneDeep(vm.donePagenationData);
            //- 滑動置頂
            vm.slideToTop();
          });
          break;
        default:
          break;
      }
    },
    //- 滑動置頂
    slideToTop: function() {
      let vm = this;
      setTimeout(() => {
        vm.$('#GiftPointsExchangeModal').animate({
          scrollTop: 0
        }, 500);
      }, 50);
    },
  },
  computed: {
    ...mapState({
      doingList: state => state.gift_manager.doingList, //- 處理中的列表
      doingPagenationData: state => state.gift_manager.doingPagenationData, //- 處理中的分頁
      doneList: state => state.gift_manager.doneList, //- 已完成的列表
      donePagenationData: state => state.gift_manager.donePagenationData, //- 已完成的分頁
    }),
  }
}